import ThemeWrapper from "../dist/ThemeWrapper";

export default function XPComponent() {
  return (
    <ThemeWrapper 
      title="Win XP Theme" 
      cssUrl="https://unpkg.com/xp.css" 
      isDarkMode={true} 
    />
  );
}